import { Component, OnDestroy, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { ActionService } from "src/app/services/action.service";
import { Globals } from "src/app/services/globals";
import { DataPool } from "src/app/services/message.service";

@Component({
  selector: "app-auto-library-selection",
  templateUrl: "./auto-library-selection.component.html",
  styleUrls: [
    "./auto-library-selection.component.scss",
    "../template/template.component.scss",
  ],
})
export class AutoLibrarySelectionComponent implements OnInit, OnDestroy {
  selectionKey = "";

  constructor(
    private dataPool: DataPool,
    private dataService: ActionService,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title
  ) {
    this.setTitle();
    this.route.params.subscribe(async (params: any[]) => {
      this.selectionKey = params["label"];
    });
  }

  private setTitle() {
    this.titleService.setTitle(this.Label);
  }

  get Label() {
    var label = this.route.snapshot.params["label"];
    return (
      "Schulio - Bibliothek " + label.charAt(0).toUpperCase() + label.slice(1)
    );
  }

  private interval;
  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  ngOnInit(): void {
    this.interval = setInterval(this.runRedirect.bind(this), 200);
  }

  private runRedirect() {
    if (this.dataPool.GeneralLibraries) {
      clearInterval(this.interval);
      const lib = this.dataPool.GeneralLibraries.filter(
        (l) =>
          l.label
            .replace(/Bibliothek[a-z]*/gi, "")
            .replace(/[a-z]*Bücherei[a-z]*/gi, "")
            .trim()
            .replace(/ \/ /gi, "-")
            .replace(/\//gi, "")
            .replace(/ /gi, "-")
            .toLowerCase() == this.selectionKey.trim().toLowerCase() ||
          `L${l.id}` == this.selectionKey
      );
      if (lib.length > 0) {
        Globals.LastSelectedLibraryId = lib[0].id;
        this.dataService
          .selectLibrary(lib[0])
          .then(() => {
            this.router.navigate(["/public"], { replaceUrl: true });
          })
          .catch(() => {
            this.router.navigate(["/"]);
          });
      } else {
        this.router.navigate(["/login"], { replaceUrl: true });
      }
    }
  }
}
